import { useEffect, useState } from "react";
import styles from "../Cadastro.module.css";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../../state/slices/userSlice";
import UploadInput from "../../../../components/Inputs/UploadInput"
import servEquipamentos from "../../../../services/login/servEquipamentos";
import { downloadConteudoBase64 } from "../../../../infra/utils/DownloadFile";

const Documentos = ({ documentos, disableUpload, setOpen, setErrorMessage, setIsLoading, addOrEdit, tipoEquipamento }) => {
    const { control, register, getValues, setValue, formState: { errors } } = useFormContext();
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [openUpload, setOpenUpload] = useState(false);
    const [uploadMessage, setUploadMessage] = useState("");
    const [severity, setSeverity] = useState("info");
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);

    useEffect(() => {
        const handleDocumentos = () => {
            if(!documentos) return;

            documentos.map((doc) => {
                
                // 2 - Obrigatoriedade conforme critério
                if(doc.Obrigatorio === 2) {
                    doc.CriterioTipoModulo = (doc.ObrigTipoModulo && tipoEquipamento === 1); // Módulo
                    doc.CriterioTipoInversor = (doc.ObrigTipoInversor && tipoEquipamento === 2); // Inversor
                    doc.CriterioTipoOutros = (doc.ObrigTipoOutros && tipoEquipamento === 3); // Outros
                }

                // Valida se limita extensões
                if(!doc.DefinirExtensoesValidas || doc.ExtensoesValidas.trim() === '') {
                    doc.ExtensoesValidas = '*';
                } 
            })
    
            setDocumentosObrigatorios(documentos);
        }

        handleDocumentos();
    }, [documentos]);

    const handleUploadArquivos = async (e) => {
        let target = e.target;
        let file = target.files ? target.files[0] : null;
    
        if (file === null) {    
            setOpen(true);
            return setErrorMessage("Selecione um arquivo");
        }
    
        try {
            const values = getValues();
    
            if (values.Id === 0) {
                const equipamento = {
                    Id: values.Id,
                    descricao: values.descricao,
                    fabricante: values.fabricante,
                    modelo: values.modelo,
                    fases: values.fases.value,
                    tipo: values.tipo.value,
                    codigoUsuario: user.codigoUsuario,
                    dataCertificacao: values.dataCertificacao,
                    potencia: values.potencia
                }
    
                setIsLoading(true);
            
    
                var codigoEquipamento = await addOrEdit(equipamento);
                values.Id = codigoEquipamento;
                setValue('Id', codigoEquipamento);
    
                setIsLoading(false);
            }
    
            const formData = new FormData();
    
            let nomeArquivoSeparadoPorPonto = file.name.split('.');
            const extensaoArquivo = nomeArquivoSeparadoPorPonto.pop();
            const nomeArquivo = nomeArquivoSeparadoPorPonto.join('.');
            const size = (file.size / 1024); // Convertendo de byte para KB

            if(values.Id === 0) return;
    
            formData.append("Arquivo", file);
            formData.append("CodigoEquipamento", values.Id);
    
            const id = e.target.id;
            let codigos = id.split("-");
    
            if (codigos[5] != 0) {
                formData.append("CodigoDocumento", codigos[5]);    
            }

            if(codigos[7] !== '*' && !codigos[7].includes(extensaoArquivo)) {
                setIsLoading(false);
                setErrorMessage(` Não é possí­vel adicionar arquivos com a extensão "${extensaoArquivo}".`);
                setOpen(true);    
                return;
            }
    
            formData.append("CodigoConfiguracaoDoc", codigos[3]);
            formData.append("CodigoClassificacaoDoc", codigos[1]);
            formData.append("NomeArquivo", nomeArquivo);
    
            formData.append("ExtensaoArquivo", extensaoArquivo);
            formData.append("TamanhoKbArquivo", Math.trunc(size));
            
            setOpenUpload(true);
            setSeverity("info");
            setUploadMessage("Upload de arquivo iniciado")
    
            setTimeout(() => {
                setOpenUpload(false);
            }, [3000]);
    
            setIsLoading(true);
            let response = await servEquipamentos.AdicionarAnexoNaUseall(formData);
        
            documentosObrigatorios.map((documento) => {
                if (documento.Id == codigos[3]) {
                    documento.CodigoDocumento = parseInt(response.Content);
                    documento.NomeArquivo = file.name;
                }
                return documento;
            })
    
            setOpenUpload(true);
            setSeverity("success");
            setUploadMessage("Arquivo enviado com sucesso");
            setIsLoading(false);
            setTimeout(() => {
                setOpenUpload(false);
            }, [1000]);
    
        } catch (err) {
    
            setIsLoading(false);
            setOpen(true);
    
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;
    
            setErrorMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
            
            if (err?.response?.status == 401) {
                setTimeout(() => {
                    dispatch(logout());
                    navigate("/");
                }, 2000);
            }
        }
    }

    const handleCloseInfo = (event, reason) => {
        if (reason  === 'clickaway') {
            setOpenUpload(false);
        }

        setOpenUpload(false);
    }

    const handleDownloadArquivo = async (event) => {
        event.preventDefault();

        let codigoDocumento = Number(event.currentTarget.value);

        if (!codigoDocumento) {
            setOpen(true);
            return setErrorMessage("Não há documento vinculado para download.");
        }

        try {
            setIsLoading(true);

            let response = await servEquipamentos.RealizarDownloadDocumento(codigoDocumento);
            downloadConteudoBase64(response.Content.Nome, response.Content.Arquivo);
            
            setUploadMessage("Arquivo enviado com sucesso");
            setIsLoading(false);
        } catch (err) {
            setOpen(true);
            setIsLoading(false);
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;

            setErrorMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
        }
    }

    const handleInputDocumentos = () => {
        return documentosObrigatorios && documentosObrigatorios.map((doc) => {
            if (doc.Obrigatorio !== 2) {
                return ContainerUpload(doc);
            } else if (doc.DocumentoCriterioSelecionado && doc.Obrigatorio === 2 && (doc.CriterioTipoModulo || doc.CriterioTipoInversor || doc.CriterioTipoOutros)) {
                return ContainerUpload(doc);
            }else if(!doc.DocumentoCriterioSelecionado && doc.Obrigatorio === 2) {
                return ContainerUpload(doc);
            }
            return null;
        });
    }

    const handleRemoverArquivo = async (event) => {
        event.preventDefault();

        let codigoDocumento = Number(event.currentTarget.value);

        if (!codigoDocumento) {
            setOpen(true);
            return setErrorMessage("Não há documento vinculado para download.");
        }

        try {
            setIsLoading(true);

            await servEquipamentos.RemoverDocumento(codigoDocumento);

            setDocumentosObrigatorios((prev) =>
            prev.map((doc) => {
                if (doc.CodigoDocumento === codigoDocumento) {
                    return {
                        ...doc,
                        CodigoDocumento: null,
                        NomeArquivo: null
                    };
                }
                return doc;
            }));

            setOpenUpload(true);
            setSeverity("success");
            
            setUploadMessage("Arquivo excluído com sucesso");            
            setIsLoading(false);
        }
        catch(err) {
            setOpenUpload(true);
            setIsLoading(false);
            setSeverity("error");
            let statusErrorMessage = err?.response?.status + " - " + err?.response?.statusText;

            setUploadMessage(err?.response?.data?.Message ? err?.response?.data?.Message : statusErrorMessage);
        }
    }


    const ContainerUpload = (doc) => {
        return (
            <div className={styles['upload-field']} key={`classifDoc-${doc.CodigoClassificacaoDoc}-configdoc-${doc.Id}-codigodoc-${doc.CodigoDocumento ?? 0}`} >
                <UploadInput 
                    handleUploadArquivos={handleUploadArquivos} 
                    handleDownloadArquivo={handleDownloadArquivo}
                    handleRemoverArquivo={handleRemoverArquivo}
                    id={`classifDoc-${doc.CodigoClassificacaoDoc}-configdoc-${doc.Id}-codigodoc-${doc.CodigoDocumento ?? 0}-extensoes-${doc.ExtensoesValidas}`} 
                    label={doc.Descricao} 
                    register={register} 
                    registerName={doc.Descricao.replace('/\s/g', '-')}
                    obrigatorio={doc.Obrigatorio} 
                    codigoDocumento={doc.CodigoDocumento || 0} 
                    disabled={disableUpload}
                    nomeArquivo={doc.NomeArquivo}
                    origemSolicitacao={false}
                    criterioTipoModulo={doc.CriterioTipoModulo}   
                    criterioTipoInversor={doc.CriterioTipoInversor}   
                    criterioTipoOutros={doc.CriterioTipoOutros}   
                    extensoesValidas={doc.ExtensoesValidas}   
                />    
            </div>
        )
    }

    return (
        <>
            <div className={styles.cadastro_equipamentos_documentos}>
                {handleInputDocumentos()}
            </div>
            <Snackbar open={openUpload} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={1000} onClose={handleCloseInfo}>
                <Alert onClose={handleCloseInfo} severity={severity} sx={{ width: '100%'}} >
                    {uploadMessage}
                </Alert>
            </Snackbar>
        </>
    )
}

export { Documentos }